import { createElement } from 'react';
import { find } from 'lodash';

export function createFilterComponent(filterId, props) {
    return createElement(FilterRegistry.getFilterType(filterId), {
        ...props,
        key: filterId,
        id: filterId,
    });
}

const filters = [];
const filterStateServiceFactories = [];

function getFilterEntry(filterId) {
    const filterEntry = find(filters, (entry) => {
        return entry.filterIdRegExp.test(filterId);
    });

    if (filterEntry === undefined) {
        throw new Error(`No filter registered for filter ID "${filterId}"`);
    }

    return filterEntry;
}

const FilterRegistry = {
    registerFilter(filterId, filterIdRegExp, filterType) {
        filters.push({
            filterId,
            filterIdRegExp,
            filterType,
        });
    },

    registerFilterStateServiceFactory(filterIdRegExp, filterStateServiceFactory) {
        filterStateServiceFactories.push({
            filterIdRegExp,
            filterStateServiceFactory,
        });
    },

    getPrimaryFilterId(filterId) {
        return getFilterEntry(filterId).filterId;
    },

    getFilterType(filterId) {
        return getFilterEntry(filterId).filterType;
    },

    getFilterStateService(filterId, filterOptions) {
        const filterStateServiceFactoryEntry = find(filterStateServiceFactories, (entry) => {
            return entry.filterIdRegExp.test(filterId);
        });

        if (filterStateServiceFactoryEntry === undefined) {
            throw new Error(`No filter state service registered for filter ID "${filterId}"`);
        }

        return filterStateServiceFactoryEntry.filterStateServiceFactory(filterId, filterOptions);
    },
};

export default FilterRegistry;
